const THREE = require('three')

import * as map from './map'
import * as speedometer from './speedometer'
import * as chargemeter from './chargemeter'
import * as shoe from './shoe'
import * as counterFg from './counterFg'
import * as counterBg from './counterBg'
import * as clock from 'src/components/game/clock'
import {TimelineMax, TweenMax, Cubic} from 'gsap'
import store from 'src/store'



// ************************************************************
//
// INIT
//
// ************************************************************
let mesh = new THREE.Object3D()
mesh.name = 'dashboard'
mesh.scale.setScalar(0.75)
mesh.position.set(0, -window.innerHeight * 0.5 + 75, 0)
// mesh.rotation.set(
//   THREE.Math.DEG2RAD * 25,
//   THREE.Math.DEG2RAD * 25,
//   THREE.Math.DEG2RAD * 0
// )


// MAP
mesh.add(map.mesh)
map.mesh.position.set(18, -10, 40)

// SPEEDO
mesh.add(speedometer.mesh)
speedometer.mesh.position.set(0, 25, -20)

// CHARGE
mesh.add(chargemeter.mesh)
chargemeter.mesh.position.set(26, 40, 0)

// SHOE
mesh.add(shoe.mesh)
shoe.mesh.position.set(0, 25, 0)

// COUNTER
let counter = new THREE.Object3D()
counter.add(counterFg.mesh)
counter.add(counterBg.mesh)
mesh.add(counter)



// ************************************************************
//
// METHODS
//
// ************************************************************
let startStage1 = () => {
  counter.position.set(0, 20, 0)
  counter.scale.setScalar(1.4)

  speedometer.start(2)
  setTimeout(() => { counterFg.start(1.4) }, 600)
  setTimeout(() => { counterBg.start(1.4) }, 600)

  map.mesh.position.y = -10
  setTimeout(() => { map.start(2) }, 1600)
}



let startStage2 = () => {
  TweenMax.to(map.mesh.position, 0.4, {y: -15, ease: Cubic.easeOut})
  let s = 0.9
  TweenMax.to(counter.scale, 0.6, {x: s, y: s, z: s, ease: Cubic.easeOut})
  TweenMax.to(counter.position, 0.6, {y: '-=35', ease: Cubic.easeOut})
  setTimeout(() => { chargemeter.start(1) }, 300)
  setTimeout(() => { shoe.start(0.8) }, 600)
}



let reset = () => {
  speedometer.reset()
  map.reset()
  counterFg.reset()
  counterBg.reset()

  shoe.reset()
  chargemeter.reset()

}





// UPDATE
let turnTime = 1
let angles = {
  curr: 0,
  goal: 0,
  offset: 0
}
let currDirection = 0
export const update = function (state, controls, trackAngles) {


  // currDirection = trackAngles[0]

  if (currDirection === trackAngles[0]) return
  currDirection = trackAngles[0]

  switch (currDirection) {
    case 0:
      TweenMax.to(mesh.rotation, 0.8, {
        delay: 0.1,
        ease: Cubic.easeOut,
        y: THREE.Math.DEG2RAD * 0
      })
      break
    case 90:
      TweenMax.to(mesh.rotation, 0.8, {
        delay: 0.3,
        ease: Cubic.easeOut,
        y: THREE.Math.DEG2RAD * 15
      })
      break
    case -90:
      TweenMax.to(mesh.rotation, 0.8, {
        delay: 0.3,
        ease: Cubic.easeOut,
        y: THREE.Math.DEG2RAD * -15
      })
      break
  }

}



// RESIZE
const onResize = function () {
  mesh.position.set(0, -window.innerHeight * 0.5 + 75, 0)
}
store.watch(function (state) {
  return store.state.browser.windowWidth
}, onResize)
store.watch(function (state) {
  return store.state.browser.windowHeight
}, onResize)






// ************************************************************
//
// EXPORT
//
// ************************************************************
let obj = {
  mesh: mesh,
  map: map,
  speedometer: speedometer,
  chargemeter: chargemeter,
  shoe: shoe,
  counter: counter,
  counterFg: counterFg,
  counterBg: counterBg,
  startStage1: startStage1,
  startStage2: startStage2,
  reset: reset,
  update: update
}
export default obj
window.dashboard = obj






// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/index.js